// Keys for graphy's NATIVE feature-flag engine (`/api/admin/feature_flags`),
// read through `useFeatureFlag`. Distinct from `FEATURE_TOGGLE` in
// ./featuretoggle, which holds GrowthBook keys read through `useFeatureValue`
// — two different backends, so keeping the key lists apart stops a key being
// handed to the wrong hook (which fails silently as a permanent `false`).
//
// Each key must match a `feature_flags.key` row in graphy exactly; an unknown
// key resolves to 'off' rather than erroring, so a typo here is invisible.

export const NATIVE_FEATURE_FLAG = {
  /**
   * Kill switch for Dashboard V2 — the `/dashboard-v2` page here and the
   * `/api/admin/dashboard_v2/*` endpoints it reads. Mirrors
   * `Dashboard::V2Config::FLAG_KEY` in graphy, which gates those endpoints to
   * 404 when off, so BOTH halves of the feature answer to this one key.
   *
   * Resolved per user, so it also supports a cohort or percentage rollout
   * through an experiment on the flag. On/off-valued: `'on'` when the flag's
   * `default_enabled` is set (or the caller is in an experiment arm).
   */
  DashboardV2: 'v2.2608.10_dashboard-v2',
} as const;

export default NATIVE_FEATURE_FLAG;
